import Vue from 'vue';
import App from './App.vue';
import store from './store';
import * as GmapVue from 'gmap-vue';
import { Mixin } from './mixin.js';

//AIzaSyBLfMqClePupJ1PpdNk66YMwt62PkXDiEM
//AIzaSyAOL7I83nOWp1IhkPeom_KYhRnoRDFpAPo
Vue.mixin(Mixin);

Vue.use(GmapVue, {
  load: {
    key: "AIzaSyC_ZLtbTQfYAJd3rCPnKKifxVa7zZOTcmo",
    libraries: 'places,geometry',
    region: 'IT',
    language: 'it',
  },
  installComponents: true
});


Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App),
}).$mount('#appstorelocator');
